import React from 'react'
import Grouplist from './Grouplist'
import Messagebox from './Messagebox'
import Groupinfo from './Groupinfo'

function ChatBox() {
    return (
        <div className = "outer-chatbox-container">
            <div className = "chatbox-container">
                <Grouplist ></Grouplist>
                <Messagebox ></Messagebox>
                <Groupinfo></Groupinfo>
            </div>
        </div>
    )
}

export default ChatBox
